import alarmCarIndex from './alarm-car-1.png';
import alarmCarPlayer from './alarm-car-2.png';
import alarmMdIndex from './alarm-md-1.png';
import alarmMdPlayer from './alarm-md-2.png';
import alarmOtherIndex from './alarm-other-1.png';
import alarmOtherPlayer from './alarm-other-2.png';
import alarmPersonIndex from './alarm-person-1.png';
import alarmPersonPlayer from './alarm-person-2.png';
import alarmPetIndex from './alarm-pet-1.png';
import alarmPetPlayer from './alarm-pet-2.png';
import alarmAnimalIndex from './alarm-animal-1.png';
import alarmAnimalPlayer from './alarm-animal-2.png';
import alarmVisitorIndex from './alarm-visitor-1.png';
import alarmVisitorPlayer from './alarm-visitor-2.png';

export default {
    alarmCarIndex,
    alarmCarPlayer,
    alarmMdIndex,
    alarmMdPlayer,
    alarmOtherIndex,
    alarmOtherPlayer,
    alarmPersonIndex,
    alarmPersonPlayer,
    alarmPetIndex,
    alarmPetPlayer,
    alarmAnimalIndex,
    alarmAnimalPlayer,
    alarmVisitorIndex,
    alarmVisitorPlayer
};
